import { CompanyActions } from '../actions';

export const initialState: string = undefined;

export function selectCompanyReducer(
  state = initialState,
  action: CompanyActions.SyncSelectedCompanyState | CompanyActions.SelectCompany | CompanyActions.ResetSelectedCompany,
): string {
  switch (action.type) {
    case CompanyActions.SYNC_SELECTED_COMPANY_STATE:
    case CompanyActions.SELECT_COMPANY: {
      return action.payload;
    }

    case CompanyActions.RESET_SELECTED_COMPANY: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
